import { EinstellungenSheetContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/EinstellungenSheetContext/EinstellungenSheetContext';
import { useContext } from 'react';

export function useEinstellungenSheetContext() {
  const context = useContext(EinstellungenSheetContext);

  if (!context) {
    throw new Error(
      'EinstellungenSheetContext must be used within EinstellungenSheetContextProvider',
    );
  }
  return context;
}
